var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49845 0.0107422L5.38477 0.39057V11.4123L5.49845 11.5239L10.703 8.4997L5.49845 0.0107422Z",
    fill: "#7160EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49658 0.0107422L0.291992 8.49971L5.49658 11.5239V6.17428V0.0107422Z",
    fill: "#A096ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50058 12.4904L5.43652 12.5672V16.4934L5.50058 16.6773L10.7083 9.46777L5.50058 12.4904Z",
    fill: "#7160EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49658 16.6773V12.4904L0.291992 9.46777L5.49658 16.6773Z",
    fill: "#A096ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50195 11.5253L10.7065 8.50121L5.50195 6.17578V11.5253Z",
    fill: "#3C2BB9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.291992 8.50121L5.4965 11.5253V6.17578L0.291992 8.50121Z",
    fill: "#7160EE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth-small.85ed55c92a95e938b852cbd59489aa30.svg";